<template>
    <div class="administration-companies-group">
        <div class="grid-x align-items">
            <div class="section-header">Virksomheder ({{ listedCompanies.length }})</div>
            <div class="auto cell">
                <button class="float-right button button-small" @click="openModal('administration-modal-company', '')">
                    <icon class="small-svg fill-white" name="building" />
                    Tilføj
                </button>
            </div>
        </div>
        <div class="grid-x companies-group">
            <div class="cell auto" v-if="sortedCompanies && sortedCompanies.length > 0">
                <transition-group class="grid-x" name="list" tag="div">
                    <div class="large-2 item" v-for="company in sortedCompanies" :ref="company.id" :key="company.id" @click="selectCompany(company)" :class="{'selected': companiesSelected.length > 0 && company.id === companiesSelected[0].id}">
                        <span class="truncate-ellipse with-icon">{{ company.name }}</span>
                        <icon class="small-svg fill-dark-gray" name="building" />
                    </div>
                </transition-group>
            </div>
           <div v-else class="user-feedback-list-group">Tryk på Tilføj for at tilføje en virksomhed</div>
        </div>
        <div class="form flexbox-end">
            <strong>Vis alle firmaer fra Drive</strong>
            <switches v-model="enabledAllCompanies" theme="custom" type-bold="false" color="blue" />
            {{ enabledAllCompanies ? 'Aktiv' : 'Ikke aktiv' }}
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Switches from 'vue-switches'

export default {
    data () {
        return {
            enabledAllCompanies: false
        }
    },
    components: {
        Switches
    },
    computed: {
        ...mapGetters({
            companies: 'getAssociatedOrganizationList',
            allCompanies: 'getAllOrganizationList',
            companiesSelected: 'getSelectedCompanies',
            applicationList: 'getApplicationList'
        }),
        listedCompanies () {
            if (this.enabledAllCompanies) {
                return this.allCompanies
            } else {
                return this.companies
            }
        },
        sortedCompanies () {
            if (this.listedCompanies && this.listedCompanies.length > 0) {
                this.listedCompanies.sort((a, b) => {
                    if (a['name'] < b['name']) {
                        return -1
                    }
                    if (a['name'] > b['name']) {
                        return 1
                    }
                    return 0
                })
                if ((this.companiesSelected && this.companiesSelected.length) < 1 && (this.listedCompanies && this.listedCompanies.length > 0)) {
                    this.setSelectedCompanies(this.listedCompanies[0])
                } else {
                    if (this.companiesSelected && this.companiesSelected.length > 0) {
                        if (this.$refs[this.companiesSelected[0].id] && this.$refs[this.companiesSelected[0].id].length > 0) {
                            this.$refs[this.companiesSelected[0].id][0].scrollIntoView()
                        }
                    }
                }
                return this.listedCompanies
            } else {
                return 0
            }
        }
    },
    methods: {
        ...mapActions({
            setSelectedCompanies: 'setSelectedCompanies',
            setCompany: 'setCompany',
            setSelectedCompaniesEmpty: 'setSelectedCompaniesEmpty',
            setApplication: 'setApplication',
            setAllCodeLists: 'setAllCodeLists',
            setApplicationSettingsDrive: 'setApplicationSettingsDrive'
        }),
        openModal (view, company) {
            new Promise((resolve, reject) => {
                resolve(this.setCompany(company))
            }).then(() => {
                this.$emit('open', view)
            })
        },
        selectCompany (company) {
            this.setSelectedCompanies(company)
        }
    },
    created () {
        this.setSelectedCompaniesEmpty()
        if (this.applicationList.filter(app => app.value.toLowerCase() === 'drive').length > 0) {
            new Promise((resolve, reject) => {
                resolve(this.setApplication(this.applicationList.filter(app => app.value.toLowerCase() === 'drive')[0].key))
            }).then(() => {
                this.setAllCodeLists()
                this.setApplicationSettingsDrive()
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/administration/administration-companies-group.vue